import BuyVipDialog from './BuyVipDialog'
import store from '@/store/store.js'
import router from '@/router/router.js'

const obj = {}

obj.install = function (Vue) {
    //1.创建组件构造器
    const Construct = Vue.extend(BuyVipDialog)

    //2.用new 的方式用组件构造器创建出来组件对象
    const buyVip = new Construct({ store, router })

    //3.将组件对象手动挂载到某一个元素上
    buyVip.$mount(document.createElement('div'))

    //4.buyVip.$el对应的就是div
    document.body.appendChild(buyVip.$el)

    //5.在原型中加入Auth
    Vue.prototype.$BuyVipDialog = buyVip
}

export default obj
